import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SendyService } from './services/sendy.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [SendyService]
})
export class SendyModule {}
